import React, { Component } from 'react';
import { Link } from "react-router-dom";
import logo from '../assets/image/logoweb.png';
import { _formatDateToText, _setTime, _logOut } from './Function';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../css/Header.css';

class HeaderAllPage extends Component {
  constructor() {
    super();
    this.state={
      time: '',
	  showInfo : null
    }
    this.timer = setInterval(()=>{
      this.setState({ time: _formatDateToText(new Date(),'') })
    }, 1000)
  }

  onAddTime = () => { _setTime() }

  logOut = () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({ 
      title: 'ยืนยันการออกจากระบบ ?', 
      text: 'คุณต้องการออกจากระบบ',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      reverseButtons: true
    }).then((result) => {
      if ( result.value ) {
        console.log("%cClick LogOut", "color:white;background-color:gray;padding:2px;");
        _logOut()
      }
    });
  }

  handleClick = () => {
	//   if(localStorage.getItem("member_no") == '02762' ||localStorage.getItem("member_no") == '09531' || localStorage.getItem("member_no") == '08484' || localStorage.getItem("member_no") == 's0338' ||  localStorage.getItem("member_no") =='00924'){
	window.open("https://www.srusct.or.th/online/confirm.php?p="+localStorage.getItem('token'));
	//   }else{
	// 	  alert("ยังไม่เปิดให้ใช้บริการ")
	//   }
	

  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    return (
		<div onClick={(e) => this.onAddTime()}>
			<div className="fix-content">
			<nav className="navbar navbar-expand-lg navbar-light">
				<div nav="top" className="nav-top">
					<img className="nav-top-logo" src={logo} />
					{/* <div className="nav-top-title-content">
						<div className="tc-1">สหกรณ์ออมทรัพย์สหภาพแรงงานรัฐวิสาหกิจรถไฟแห่งประเทศไทย จำกัด</div>
						<div className="tc-2 n-tc-2">The State Railway Workers' Union Saving and Credit Cooperative of Thailand limited</div>
					</div> */}
				</div>
				<div className="nav-time">{this.state.time}</div>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarNavDropdown">
					<ul className="navbar-nav navbar-nav-login nav-all-page">
						<li className="nav-item nav-active">
						<a className="nav-link" href="/online/dashboard">หน้าแรก</a>
						</li>
						<li className="nav-item">
						<a className="nav-link">ข้อความ</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/share">หุ้น</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/deposit">เงินฝาก</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/loan">เงินกู้</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/welfare">สวัสดิการ</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/payment">พิมพ์ใบเสร็จ</a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/guarantor">ภาระการค้ำประกัน</a>
						</li>
						<li className="nav-item" >
						<a className="nav-link"><span onClick={this.handleClick}>ยืนยันยอด</span></a>
						</li>
						<li className="nav-item">
						<a className="nav-link" href="/online/password">เปลี่ยนรหัสผ่าน</a>
						</li>
						<li className="nav-item">
						<a className="nav-link"><span onClick={this.logOut}>ออกจากระบบ</span></a>
						</li>
					</ul>
				</div>
			</nav>
			</div>
			<div className="nav-islogin">
				<span><Link to="/online/dashboard">หน้าแรก</Link></span>
				<span><Link to="/online/share">หุ้น</Link></span>
				<span><Link to="/online/deposit">เงินฝาก</Link></span>
				<span><Link to="/online/loan">เงินกู้</Link></span>
				<span><Link to="/online/welfare">สวัสดิการ</Link></span>
				<span><Link to="/online/payment">พิมพ์ใบเสร็จ</Link></span>
				<span><Link to="/online/guarantor">ภาระการค้ำประกัน</Link></span>
				<span onClick={this.handleClick}>ยืนยันยอด</span>
				<span><Link to="/online/password">เปลี่ยนรหัสผ่าน</Link></span>
				<span onClick={this.logOut}>ออกจากระบบ</span>
			</div>
		</div>
    );
  }
}
export default HeaderAllPage;